import consumerApi from "api/services/consumer-api";
import { Brand } from "custom-types/Brand";
import formatImgixUrl from "utils/formatImgixUrl";
import logError from "utils/logError";

export const getBrand = async (slug: string): Promise<Brand | undefined> => {
  try {
    const { data } = await consumerApi.get(`/api/brands/v1/${slug}`);

    return { ...data, logo: formatImgixUrl(data.logo) } as Brand;
  } catch (e) {
    logError(e.message, {
      functionName: "getBrand",
      service: "consumer",
      statusCode: e.statusCode,
    });

    return;
  }
};
